(function () {
  'use strict';

  function initAdvertorial(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    window.dataLayer = window.dataLayer || [];
    var pageName = root.dataset.pageName || 'baby_constipation_advertorial';

    function track(eventName, properties) {
      window.dataLayer.push(Object.assign({
        event: eventName,
        page_name: pageName
      }, properties || {}));
    }

    track('nb_advertorial_view');

    root.querySelectorAll('[data-nbc-scroll]').forEach(function (control) {
      control.addEventListener('click', function (event) {
        var targetSelector = control.getAttribute('href');
        if (!targetSelector || targetSelector.charAt(0) !== '#') return;
        var target = root.querySelector(targetSelector);
        if (!target) return;

        event.preventDefault();
        track('nb_advertorial_cta_click', {
          cta_location: control.dataset.ctaLocation || 'unknown',
          cta_label: control.textContent.trim()
        });
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    root.querySelectorAll('[data-nbc-link]').forEach(function (control) {
      control.addEventListener('click', function () {
        track('nb_advertorial_cta_click', {
          cta_location: control.dataset.ctaLocation || 'unknown',
          cta_label: control.textContent.trim(),
          cta_destination: control.getAttribute('href') || ''
        });
      });
    });

    var purchaseForm = root.querySelector('[data-nbc-purchase-form]');
    if (purchaseForm) {
      var planInput = purchaseForm.querySelector('[data-nbc-selling-plan]');
      var nativeForm = purchaseForm.querySelector('form[action*="/cart/add"]');
      var buttons = Array.from(root.querySelectorAll('[data-nbc-purchase-trigger]'));
      var options = Array.from(purchaseForm.querySelectorAll('[data-nbc-option]'));
      var errorBox = root.querySelector('[data-nbc-checkout-error]');
      var statusBox = root.querySelector('[data-nbc-checkout-status]');
      var busy = false;
      var controller = null;
      var attemptNumber = 0;
      var initialDisabled = new Map(buttons.concat(options).map(function (control) {
        return [control, control.disabled];
      }));
      var offerCopies = Array.from(root.querySelectorAll('[data-nbc-one-time-copy]')).map(function (element) {
        return { element: element, subscription: element.innerHTML };
      });

      function syncPurchaseOption() {
        var selected = purchaseForm.querySelector('[data-nbc-option]:checked');
        var subscription = selected && selected.value === 'subscription';
        if (planInput) planInput.disabled = !subscription;
        buttons.forEach(function (button) {
          if (!initialDisabled.get(button)) {
            button.textContent = subscription ? 'Start My First Month' : 'Continue to Checkout';
          }
        });
        offerCopies.forEach(function (copy) {
          if (subscription) copy.element.innerHTML = copy.subscription;
          else copy.element.textContent = copy.element.dataset.nbcOneTimeCopy;
        });
        root.querySelectorAll('[data-nbc-subscription-only]').forEach(function (element) {
          element.hidden = !subscription;
        });
      }

      function setBusy(value) {
        busy = value;
        buttons.concat(options).forEach(function (control) {
          control.disabled = value || initialDisabled.get(control);
        });
        buttons.forEach(function (button) {
          if (value) button.setAttribute('aria-busy', 'true');
          else button.removeAttribute('aria-busy');
        });
        nativeForm.setAttribute('aria-busy', String(value));
        statusBox.textContent = value ? 'Adding your selection. Opening secure checkout next.' : '';
      }

      options.forEach(function (option) {
        option.addEventListener('change', function () {
          syncPurchaseOption();
          track('nb_advertorial_purchase_option', {
            purchase_option: option.value
          });
        });
      });
      syncPurchaseOption();

      // Capture only this native form. The shared component also submits on the
      // target, so stop it here to guarantee one POST and avoid its drawer step.
      nativeForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (busy || !nativeForm.reportValidity()) return;

        syncPurchaseOption();
        var submitter = event.submitter;
        var location = submitter && submitter.dataset.ctaLocation || 'purchase_box';
        var data = new FormData(nativeForm);
        var expectedVariant = String(data.get('id'));
        var expectedPlan = String(data.get('selling_plan') || '');
        var expectedQuantity = Number(data.get('quantity') || 1);
        var selected = purchaseForm.querySelector('[data-nbc-option]:checked');
        var subscription = selected && selected.value === 'subscription';
        var thisAttempt = ++attemptNumber;
        var timeout;
        errorBox.hidden = true;
        track('nb_advertorial_cta_click', {
          cta_location: location,
          cta_label: submitter ? submitter.textContent.trim() : ''
        });
        setBusy(true);

        try {
          if (subscription && !expectedPlan) {
            throw new Error('This subscription is unavailable. Please choose another purchase option.');
          }
          controller = new AbortController();
          timeout = window.setTimeout(function () { controller.abort(); }, 20000);
          var response = await fetch(Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: data,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: controller.signal
          });
          var result = await response.json();
          if (thisAttempt !== attemptNumber) return;
          if (!response.ok) {
            throw new Error(result.description || result.message || 'Unable to add your selection. Please try again.');
          }
          var items = result.items || [result];
          var item = items.length === 1 && items[0];
          var actualPlan = item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
          if (!item || String(item.variant_id || item.id) !== expectedVariant ||
              String(actualPlan && actualPlan.id || '') !== expectedPlan ||
              !Number.isFinite(item.quantity) || item.quantity < expectedQuantity) {
            throw new Error('We could not confirm your selection. Please check your cart before trying again.');
          }
          window.clearTimeout(timeout);
          // Only this validated server response records success and navigates.
          // Do not emit cart:change: the shared drawer opens on that event.
          track('nb_advertorial_add_to_cart', {
            cta_location: location,
            purchase_option: expectedPlan ? 'subscription' : 'one_time',
            product_id: item.product_id,
            variant_id: item.variant_id || item.id,
            selling_plan_id: expectedPlan
          });
          nativeForm.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true, detail: { items: items }
          }));
          window.location.assign(Shopify.routes.root + 'checkout');
        } catch (error) {
          if (thisAttempt !== attemptNumber) return;
          var message = error.name === 'AbortError' || error instanceof TypeError || error instanceof SyntaxError
            ? 'We could not confirm the add because the connection was interrupted. Please check your cart before trying again.'
            : error.message;
          setBusy(false);
          errorBox.textContent = message;
          errorBox.hidden = false;
          errorBox.focus({ preventScroll: true });
          track('nb_advertorial_add_to_cart_error', { cta_location: location, error_message: message });
          nativeForm.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: message } }));
        } finally {
          window.clearTimeout(timeout);
        }
      }, true);

      window.addEventListener('pageshow', function () {
        // A back/forward-cache restoration retains disabled DOM controls.
        ++attemptNumber;
        if (controller) controller.abort();
        setBusy(false);
        syncPurchaseOption();
      });
    }

    var cartCount = root.querySelector('[data-nbc-cart-count]');
    document.documentElement.addEventListener('cart:change', function (event) {
      if (!cartCount || !event.detail || !event.detail.cart) return;
      var itemCount = event.detail.cart.item_count || 0;
      cartCount.textContent = itemCount;
      cartCount.hidden = itemCount < 1;
    });

    var reachedDepths = {};
    var scrollDepths = [25, 50, 75, 90];

    function checkScrollDepth() {
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var percent = Math.round((window.scrollY / scrollable) * 100);

      scrollDepths.forEach(function (depth) {
        if (percent >= depth && !reachedDepths[depth]) {
          reachedDepths[depth] = true;
          track('nb_advertorial_scroll_depth', { percent_scrolled: depth });
        }
      });
    }

    window.addEventListener('scroll', checkScrollDepth, { passive: true });
    checkScrollDepth();

    var hero = root.querySelector('[data-nbc-hero]');
    var productReveal = root.querySelector('[data-nbc-product-reveal]');
    var purchaseSection = root.querySelector('[data-nbc-purchase-section]');
    var finalSection = root.querySelector('[data-nbc-final]');
    var sticky = root.querySelector('[data-nbc-sticky]');
    var stickyButton = sticky ? sticky.querySelector('button') : null;
    var heroIsVisible = true;
    var purchaseIsVisible = false;
    var finalIsVisible = false;

    function updateSticky() {
      if (!sticky) return;
      var isVisible = !heroIsVisible && !purchaseIsVisible && !finalIsVisible;
      sticky.classList.toggle('is-visible', isVisible);
      sticky.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      if (stickyButton) stickyButton.tabIndex = isVisible ? 0 : -1;
    }

    if ('IntersectionObserver' in window && hero) {
      var heroObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          heroIsVisible = entry.isIntersecting;
          updateSticky();
        });
      }, { threshold: 0.05 });
      heroObserver.observe(hero);
    }

    if ('IntersectionObserver' in window && productReveal) {
      var productObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || productReveal.dataset.reached === 'true') return;
          productReveal.dataset.reached = 'true';
          track('nb_advertorial_product_reached');
        });
      }, { threshold: 0.2 });
      productObserver.observe(productReveal);
    }

    if ('IntersectionObserver' in window && purchaseSection) {
      var purchaseObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          purchaseIsVisible = entry.isIntersecting;
          updateSticky();
        });
      }, { threshold: 0.15 });
      purchaseObserver.observe(purchaseSection);
    }

    if ('IntersectionObserver' in window && finalSection) {
      var finalObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          finalIsVisible = entry.isIntersecting;
          updateSticky();
        });
      }, { threshold: 0.1 });
      finalObserver.observe(finalSection);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-nbc-root]').forEach(initAdvertorial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAdvertorial(event.target.querySelector('[data-nbc-root]'));
  });
})();
